import { Center, Text } from '@zorro/web/design-system';

import { AppLayoutConstants } from '../AppLayoutUtils';

type Props = {
  fullName: string;
};
export const AppLayoutHeaderImpersonation = ({ fullName }: Props) => {
  return (
    <Center
      bg="var(--color-background-system-primary-brand)"
      w="100vw"
      h={AppLayoutConstants.IMPERSONATION_BAR_HEIGHT}
      px="var(--space-12)"
    >
      <Text
        c="var(--color-text-on-primary)"
        size="sm"
        fw={700}
        ta="center"
        truncate="end"
      >
        Joint session:
        <Text ml="0.25rem" c="var(--color-text-on-primary)">
          browsing employee mode with {fullName}
        </Text>
      </Text>
    </Center>
  );
};
